import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Loader } from "semantic-ui-react";
import { getProjectsInfolist } from "../../api/BorrowerApi";
import { getMockProjectsInfolist } from "../../api/mock/MockBorrowerApi";
import { formatDataProperties, handleErrorResponse } from "../../Helpers";
import { IProjectsView } from "../interfaces/Borrower";
import { IErrorResponse, IProxyUser } from "../interfaces/Global";
import BCMenuBar from "../ui/BCMenuBar";
import BCMessage from "../ui/BCMessage";
import BCTable from "../ui/BCTable";
import BWExportButton from "./BWExportButton";
import BWSearchBox from "./BWSearchBox";
import "../../styles/borrower/vendor-form.scss";
import { handleApiPromise } from "../../helpers/GlobalHelper";

interface IBWProjects {
  isGreaterThanMobile: boolean;
  isGreaterThanTablet: boolean;
  isSidebar: boolean;
  isMessage: boolean;
  setIsMessage: React.Dispatch<React.SetStateAction<boolean>>;
  errorResponse: IErrorResponse | undefined;
  setErrorResponse: React.Dispatch<React.SetStateAction<IErrorResponse | undefined>>
  proxyUser: IProxyUser | undefined;
}

const BWProjects = ({ ...props }: IBWProjects) => {
  const [isFirstLoad, setIsFirstLoad] = useState(true as boolean);
  const [isLoading, setIsLoading] = useState(true as boolean);
  const [projectsInfoData, setProjectsInfoData] = useState([] as IProjectsView[]);

  const history = useHistory();
  const handleError = useCallback(() => {
    history.push("/error");
  }, [history]);

  const propertyOfProject = (name: keyof IProjectsView) : string => name;
  const convertToTableFormat = (projects : IProjectsView[]) => {
    const result = [] as any;
    projects.forEach((project) => {
      const resultItem = {} as any;
      Object.entries(project).forEach(([key, value]) => {
        if(key === propertyOfProject("createdOn")) {
          resultItem[key] = new Date(key).toLocaleDateString();
        }
        else if (key === propertyOfProject("loanNumber")) {
          resultItem[key] = <Link className="inspection-detail-link" to={{ pathname: `/project/loan/${project.id}`, state: { project }}}>{value}</Link>;
        }
        else {
          resultItem[key] = value;
        }
      });
      result.push(resultItem);
    });

    const formattedProjects = formatDataProperties(result, [
      {field: propertyOfProject("tcName"), action: "rename", name: "TC Name"}, 
      {field: propertyOfProject("tcPhoneNumber"), action: "rename", name: "TC Phone Number"}
    ]);
    
    return formattedProjects;
  };

  useEffect(() => {
    const getProjectsInfoAysnc = async () => {
      const data = await handleApiPromise(
        () => getProjectsInfolist(props.proxyUser && props.proxyUser.id),
        () => getMockProjectsInfolist(),
        (response) => handleErrorResponse(response, props.setIsMessage, props.setErrorResponse)
      ) || [];

      const projectsViews = [] as IProjectsView[];
      data.forEach((projectsInfolistItem) => {
        projectsViews.push(projectsInfolistItem as IProjectsView);
      });

      setProjectsInfoData(projectsViews);
      setIsLoading(false);
    };

    if (isFirstLoad) {
      getProjectsInfoAysnc();
    }
  }, [props.setIsMessage, props.setErrorResponse, setIsLoading, handleError, props.proxyUser, isFirstLoad]);

  useEffect(() => {
    setIsFirstLoad(false);
  }, []);

  return (
    <div className={(props.isGreaterThanTablet && props.isSidebar) ? "landing-page hide-sidebar" : "landing-page sidebar"}>
      {isLoading ? <Loader active inline="centered" size="big" /> : <React.Fragment>
        <BCMessage
          animation={"fly down"}
          duration={750}
          visible={props.isMessage}
          transitionOnMount
          styles="full-width"
          onDismiss={() => props.setIsMessage(false)}
          errorResponse={props.errorResponse}
        />
        <BCMenuBar
          isGreaterThanMobile={props.isGreaterThanMobile}
          leftChildren={[<BWExportButton />]}
          rightChildren={[<BWSearchBox />]}
        />
        <BCTable
          dataRules={[{ field: "Id", rule: "hide" }, { field: "Work Inspection Company Organization Id", rule: "hide" }]}
          data={convertToTableFormat(projectsInfoData)}
          selectable
          overflowX
          overflowY
          dataSingleLine
          sortable={["Loan Property", "Loan", "Project Number", "City", "State", "Property Type", "Borrower", "TC Name", "Builder"]}
          pagination={25}
        />
      </React.Fragment>}
    </div>
  );
};

export default BWProjects;